var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRewind = function SvgRewind(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.4 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2,1.6H6.67l.8-.8a.45.45,0,0,0,0-.66.45.45,0,0,0-.66,0l-1.6,1.6a.46.46,0,0,0,0,.67L6.81,4a.46.46,0,0,0,.66,0,.46.46,0,0,0,0-.67l-.8-.8H7.2A6.26,6.26,0,1,1,.94,8.8.47.47,0,0,0,0,8.8,7.2,7.2,0,1,0,7.2,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43,4a.51.51,0,0,0,.34.14A.47.47,0,0,0,5.1,4a.48.48,0,0,0,0-.67L3.83,2.07,5.1.8a.47.47,0,0,0,0-.66.46.46,0,0,0-.67,0l-1.6,1.6a.48.48,0,0,0,0,.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.71 11.23 5.71 6.46 4.13 6.46 4.13 7.31 4.76 7.31 4.76 11.23 5.71 11.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,11.22c1.35,0,1.77-1,1.77-2.44S9.85,6.37,8.5,6.37s-1.76,1-1.76,2.41S7.15,11.22,8.5,11.22Zm0-4c.77,0,.86.75.86,1.56s-.09,1.59-.86,1.59-.86-.74-.86-1.59S7.73,7.22,8.5,7.22Z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRewind, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Rewind.c75e43dd.svg";
export { ForwardRef as ReactComponent };